/**
 * Static lookup table and option metadata types for eSIM upsell package UI.
 *
 * Ticket SKU ids: `App.LoyaltyEsimUpsellTicketId` in `typings/app/loyalty.d.ts`.
 * Catalog shapes: `App.LoyaltyEsimUpsellCatalog*`.
 * Lookup helpers: `loyalty/lib/esims/esimUpsellTicketUtils.ts`.
 */

export type LoyaltyEsimUpsellKind = 'gb_pack' | 'unlimited_days'

type LoyaltyEsimUpsellGBPackMetadata = {
  ticketId: App.LoyaltyEsimUpsellGBPackTicketId
  kind: 'gb_pack'
  gb: number
}

type LoyaltyEsimUpsellUnlimitedMetadata = {
  ticketId: App.LoyaltyEsimUpsellUnlimitedTicketId
  kind: 'unlimited_days'
  days: number
}

export type LoyaltyEsimUpsellTicketMetadata =
  | LoyaltyEsimUpsellGBPackMetadata
  | LoyaltyEsimUpsellUnlimitedMetadata

type LoyaltyEsimUpsellTicketMetadataByTicketId = {
  [TicketId in App.LoyaltyEsimUpsellGBPackTicketId]: LoyaltyEsimUpsellGBPackMetadata & { ticketId: TicketId }
} & {
  [TicketId in App.LoyaltyEsimUpsellUnlimitedTicketId]: LoyaltyEsimUpsellUnlimitedMetadata & { ticketId: TicketId }
}

export const ESIM_UPSELL_TICKET_METADATA = {
  '1GB': { ticketId: '1GB', kind: 'gb_pack', gb: 1 },
  '3GB': { ticketId: '3GB', kind: 'gb_pack', gb: 3 },
  '5GB': { ticketId: '5GB', kind: 'gb_pack', gb: 5 },
  '10GB': { ticketId: '10GB', kind: 'gb_pack', gb: 10 },
  '20GB': { ticketId: '20GB', kind: 'gb_pack', gb: 20 },
  'UNL_3D': { ticketId: 'UNL_3D', kind: 'unlimited_days', days: 3 },
  'UNL_7D': { ticketId: 'UNL_7D', kind: 'unlimited_days', days: 7 },
  'UNL_10D': { ticketId: 'UNL_10D', kind: 'unlimited_days', days: 10 },
  'UNL_15D': { ticketId: 'UNL_15D', kind: 'unlimited_days', days: 15 },
} satisfies LoyaltyEsimUpsellTicketMetadataByTicketId
